import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function FormulaOneNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Formula 1",
    links: [
      {href: "/formula1", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

FormulaOneNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default FormulaOneNav



// WEBPACK FOOTER //
// ./modules/FormulaOne/nav/FormulaOneNav.js